import { EMPTY_OBJECT } from '../../../constants/common'
import { isValueStringType } from '../../../utils/common'
import { GretaAIChatCodeBlock } from '../GretaAIChatCodeBlock'
import {
  getIsGretaAIChatMermaid,
  GretaAIChatMermaid,
} from '../GretaAIChatMermaid'

function GretaAIChatMarkdownPre({ children }) {
  const { children: source, className } = children?.props ?? EMPTY_OBJECT

  const hasStringSource = isValueStringType(source)
  const isMermaid = hasStringSource && getIsGretaAIChatMermaid(className)

  return isMermaid ? (
    <GretaAIChatMermaid code={source.trim()} />
  ) : (
    <GretaAIChatCodeBlock code={hasStringSource ? source.trimEnd() : undefined}>
      {children}
    </GretaAIChatCodeBlock>
  )
}

export default GretaAIChatMarkdownPre
